export { Card, type CardProps } from "./card";
export { Card as default } from "./card";
